

export const createMedico = async (doctorInfo) => {
  let medicoObject = {
    doctorInfo : doctorInfo
  }

    try {
      const response = await fetch('https://northamerica-northeast1-auto-factura-erps.cloudfunctions.net/createNuevoMedico', {
        method: 'POST',
        body: JSON.stringify(medicoObject),
        headers: {
          'Content-Type': 'application/json',
        },
      });
        await response.json();
      return "success"
    } catch (error) {
      return error
    }
  }

export const createMedicoMail = async (nombre,hospital,correoCalidad,cedula,telefono,correoMedico,today,especialidad) => {
    try {
        let sending = "https://apibot.hospitalesmac.app/public/surgeryroom/email/"+correoCalidad+"/"+nombre+"/<br>%20Fecha%20de%20solicitud:"+today+"<br>%20A%20continuación%20se%20presentan%20los%20datos%20del%20Nuevo%20Médico:%20<br>%20Nombre%20del%20médico:"+nombre+"<br>%20Unidad%20Hospitalaria:"+hospital+"<br>%20Cedula%20profesional%20de%20la%20especialidad:"+cedula+"<br>%20Telefono%20del%20médico:"+telefono+"<br>%20Correo%20electronico%20del%20médico:"+correoMedico+"<br>%Especialidad%20del%20médico:"+especialidad+"<br>/" + process.env.REACT_APP_EMAIL_TOKEN
        let sendingRespaldo = "https://apibot.hospitalesmac.app/public/surgeryroom/email/jose.campos@hospitalesmac.com/"+nombre+"/<br>%20Fecha%20de%20solicitud:"+today+"<br>%20A%20continuación%20se%20presentan%20los%20datos%20del%20Nuevo%20Médico:%20<br>%20Nombre%20del%20médico:"+nombre+"<br>%20Unidad%20Hospitalaria:"+hospital+"<br>%20Cedula%20profesional%20de%20la%20especialidad:"+cedula+"<br>%20Telefono%20del%20médico:"+telefono+"<br>%20Correo%20electronico%20del%20médico:"+correoMedico+"<br>%Especialidad%20del%20médico:"+especialidad+"<br>/" + process.env.REACT_APP_EMAIL_TOKEN

        fetch(sending)
            .then(function(response) {
                if(response.ok) {
                  //console.log(response)
                } else {
                  //console.log('Respuesta de red OK pero respuesta HTTP no OK');
                }
              })
              .catch(function(error) {
                //console.log('Hubo un problema con la petición Fetch:' + error.message);
              });
              fetch(sendingRespaldo)
              .then(function(response) {
                  if(response.ok) {
                    //console.log(response)
                  } else {
                    //console.log('Respuesta de red OK pero respuesta HTTP no OK');
                  }
                })
                .catch(function(error) {
                  //console.log('Hubo un problema con la petición Fetch:' + error.message);
                });
        return "success"
    } catch (error) {
        //console.log(error)
        return error
    }
  }

  export const createMedicoCRM = async (doctorInfo) => {
    try {
        const response = await fetch('https://agendaqx-createnuevomedico-1082492640140.us-south1.run.app', {
          method: 'POST',
          body: JSON.stringify(doctorInfo),
          headers: {
            'Content-Type': 'application/json',
          },
        });
        await response.json();
        return "success"
    } catch (error) {
        return error
    }
  }